/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ClientManagementGetOtFieldsGet$Plain$Params {
  otRepository?: string;
}

export function clientManagementGetOtFieldsGet$Plain(http: HttpClient, rootUrl: string, params?: ClientManagementGetOtFieldsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, clientManagementGetOtFieldsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('otRepository', params.otRepository, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

clientManagementGetOtFieldsGet$Plain.PATH = '/ClientManagement/GetOtFields';
